import type { ParseNode } from '../parser/ParseNode.mts';

export function IsInTailPosition(_node: ParseNode): boolean {
  return false;
}
